import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAndroidComponent } from './simple-icons-android.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAndroidComponent ],
    exports:      [ SimpleIconsAndroidComponent ],
    bootstrap:    []
})
export class SimpleIconsAndroidModule {}
